module.exports = __webpack_public_path__ + "img/xiaoshou.06c64505.svg";